import type { ActivityTab } from './recordingActivity';

export const ACTIVITY_TAB_STYLES: Record<ActivityTab, { icon: string; color: string }> = {
  elevation: { icon: 'landscape', color: '#FDDF00' },
  ascent: { icon: 'trending_up', color: '#E0A85C' },
  heartRate: { icon: 'favorite', color: '#DB2B35' },
  steps: { icon: 'directions_walk', color: '#A855F7' },
  pace: { icon: 'timer', color: '#2CC2E3' },
};
